// Centralized theming helpers
// Priority: env var override -> host pattern -> fallback

const SAS_NAVY = '#0C2340';
const STAGING_PURPLE = '#ae87bc';

export function isProdHost(hostname) {
  const host = (hostname || (typeof window !== 'undefined' ? window.location.host : '') || '').toLowerCase();
  // Treat both primary prod hosts as production
  return /(^|\.)portal\.semesteratsea\.org$/.test(host) || /(^|\.)prodportal\.semesteratsea\.org$/.test(host);
}

export function getBrandBlue(options = {}) {
  const { host, envColor } = options;
  // Allow CI/deploy to inject an explicit brand color
  const injected = envColor || (typeof process !== 'undefined' ? process.env.REACT_APP_BRAND_COLOR : undefined);
  if (injected && /^#?[0-9a-f]{3,8}$/i.test(injected)) {
    return injected.startsWith('#') ? injected : `#${injected}`;
  }

  const hostname = host || (typeof window !== 'undefined' ? window.location.host : '');

  if (isProdHost(hostname)) {
    return SAS_NAVY;
  }

  // Heuristic: anything with dev/staging in hostname uses staging color
  const lower = (hostname || '').toLowerCase();
  if (lower.includes('staging') || lower.includes('dev')) {
    return STAGING_PURPLE;
  }

  // Fallback for other non-prod envs
  return STAGING_PURPLE;
}

export const colors = {
  SAS_NAVY,
  STAGING_PURPLE,
};



// WEBPACK FOOTER //
// ./src/theme.js